import { render, staticRenderFns } from "./GlobeActivitySlimCard.vue?vue&type=template&id=5888d479&"
import script from "./GlobeActivitySlimCard.vue?vue&type=script&lang=js&"
export * from "./GlobeActivitySlimCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports